import { render, staticRenderFns } from "./CellBalanceView.vue?vue&type=template&id=a220e320"
import script from "./CellBalanceView.vue?vue&type=script&lang=js"
export * from "./CellBalanceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports